import { Header, Space } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { ConversationOrderSummarySource } from './ConversationOrderSummarySource'
import { type IConversationVendorOrderSummaryGroup } from './ConversationVendorOrderSummary'
import messages from './messages'

export interface IConversationVendorOrderSummaryHeadingProps {
  group: IConversationVendorOrderSummaryGroup
}

export const ConversationVendorOrderSummaryHeading = ({
  group,
}: IConversationVendorOrderSummaryHeadingProps) => {
  const intl = useProcurifyIntl()
  const count = group.items.length
  const { vendor } = group

  return (
    <Space direction='horizontal' size='small' align='center'>
      <Header as='h5'>
        {vendor
          ? intl.formatMessage(messages.groupHeading, { count })
          : intl.formatMessage(messages.heading, { count })}
      </Header>
      {vendor && <ConversationOrderSummarySource vendor={vendor} />}
    </Space>
  )
}
